(function ($, window, undefined) {

    function ImageGallery(args) {
        this.defaults = {
            selectors: {
                widgetContainer: '[data-image-gallery]',
                modal: '[data-image-gallery-modal]',
                openButton: '[data-image-gallery-open]',
                closeButton: '[data-image-gallery-close]',
                swiper: '[data-image-gallery-swiper]',
                slide: '[data-image-gallery-slide]',
                previousButton: '[data-image-gallery-previous]',
                nextButton: '[data-image-gallery-next]',
                pagination: '[data-image-gallery-pagination]',
                video: '[data-image-gallery-video]'
            }
        };

        this.options = $.extend(true, {}, this.defaults, args);
        this.$widgetContainer = $(this.options.selectors.widgetContainer);
        this.$modal = this.parent(this.options.selectors.modal);
        this.$closeButton = this.parent(this.options.selectors.closeButton);
        this.$swiper = this.parent(this.options.selectors.swiper);
        this.players = [];
        this.previousFocus = null;
        this.isOpen = false;

        if (!this.$modal.length || !this.$swiper.length) {
            return;
        }

        this.initPlayers();
        this.initSwiper();
        this.bindEvents();
    }

    ImageGallery.prototype.parent = function (selector) {
        return $(selector, this.$widgetContainer);
    };

    ImageGallery.prototype.initPlayers = function () {
        var self = this;

        if (typeof window.Plyr === 'undefined') {
            return;
        }

        this.parent(this.options.selectors.video).each(function () {
            self.players.push(new window.Plyr(this, {
                controls: [
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'volume',
                    'captions',
                    'settings',
                    'pip',
                    'airplay',
                    'fullscreen'
                ]
            }));
        });
    };

    ImageGallery.prototype.initSwiper = function () {
        var self = this;

        this.swiper = new window.Swiper(this.$swiper[0], {
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: this.parent(this.options.selectors.nextButton)[0],
                prevEl: this.parent(this.options.selectors.previousButton)[0]
            },
            pagination: {
                el: this.parent(this.options.selectors.pagination)[0],
                type: 'fraction'
            },
            on: {
                slideChangeTransitionStart: function () {
                    self.pauseVideos();
                }
            }
        });
    };

    ImageGallery.prototype.open = function (slideIndex, playVideo) {
        var self = this;
        var index = isNaN(slideIndex) ? 0 : slideIndex;

        this.previousFocus = document.activeElement;
        this.isOpen = true;
        this.$modal.removeAttr('hidden').attr('aria-hidden', 'false');
        $('body').addClass('image-gallery-modal-open');
        this.$swiper.scrollLeft(0);
        this.swiper.update();
        this.swiper.slideTo(index, 0);
        this.$closeButton.focus();

        if (playVideo) {
            window.setTimeout(function () {
                self.playActiveVideo();
            }, 100);
        }
    };

    ImageGallery.prototype.close = function () {
        this.pauseVideos();
        this.isOpen = false;
        this.$modal.attr('hidden', 'hidden').attr('aria-hidden', 'true');
        $('body').removeClass('image-gallery-modal-open');

        if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
            this.previousFocus.focus();
        }
    };

    ImageGallery.prototype.playActiveVideo = function () {
        var activeSlide = this.parent(this.options.selectors.slide).eq(this.swiper.activeIndex);

        if (activeSlide.attr('data-slide-type') === 'video' && this.players.length) {
            var playResult = this.players[0].play();
            if (playResult && typeof playResult.catch === 'function') {
                playResult.catch(function () {});
            }
        }
    };

    ImageGallery.prototype.pauseVideos = function () {
        for (var i = 0; i < this.players.length; i++) {
            this.players[i].pause();
        }
    };

    ImageGallery.prototype.trapFocus = function (event) {
        var focusable = this.$modal
            .find('a[href], button:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])')
            .filter(':visible');

        if (!focusable.length) {
            return;
        }

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    };

    ImageGallery.prototype.bindEvents = function () {
        var self = this;

        this.parent(this.options.selectors.openButton).on('click', function () {
            self.open(parseInt($(this).attr('data-image-gallery-open'), 10), $(this).is('[data-image-gallery-play-video]'));
        });

        this.$closeButton.on('click', function () {
            self.close();
        });

        this.$modal.on('click', function (event) {
            if (event.target === self.$modal[0]) {
                self.close();
            }
        });

        $(document).on('keydown', function (event) {
            if (!self.isOpen) {
                return;
            }

            if (event.key === 'Escape' || event.keyCode === 27) {
                event.preventDefault();
                self.close();
            } else if (event.key === 'Tab' || event.keyCode === 9) {
                self.trapFocus(event);
            }
        });
    };

    window.SVHA = window.SVHA || {};
    window.SVHA.Widgets = window.SVHA.Widgets || {};
    window.SVHA.Widgets.ImageGallery = ImageGallery;

})(jQuery, window);
